<template v-slot:searchAreaHeader>
  <div class="app-main-inner-row extension-conditions-form advance-payment-search-areaheader">
    <el-form inline label-position="left">
      <el-form-item label="" class="el-form-item-search">
        <el-radio-group v-model="searchConditions.searchMode" no="0">
          <el-radio :label="1">{{ $t('AdvancePayment.BalanceDetail') }}</el-radio>
          <el-radio :label="2">{{ $t('AdvancePayment.FinanceBalance') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  name: 'AdvancePaymentSearchAreaHeader',
  props: {
    searchConditions: { type: Object, required: true }
  }
}
</script>
<style lang="scss">
.advance-payment-search-areaheader {
  .el-form-item-search {
    margin-right: 15px;
    .el-form-item__label {
      padding-right: 5px;
      font-size: 14px !important;
    }
    .el-form-item__content {
      .el-radio {
        margin-right: 3px;
        .el-radio__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-checkbox {
        .el-checkbox__label {
          font-size: 13px !important;
          padding-left: 2px;
        }
      }
      .el-date-editor {
        //.el-input__prefix {
        //  display: none;
        //}
      }
      .el-input {
        width: 110px;
      }
      .el-input__inner {
        padding-left: 20px !important;
        padding-right: 5px !important;
        width: 110px;
      }
    }
  }
}
</style>
